"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _embedUtils = require("./embedUtils");
function CreateTransformEthAddressMiddleware() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$override = _ref.override,
    override = _ref$override === void 0 ? true : _ref$override;
  return function (req, res, next, end) {
    next(function (done) {
      if (req.method === 'eth_accounts') {
        res.result = (0, _embedUtils.transformEthAddress)(res.result);
      }
      done();
    });
  };
}
var _default = CreateTransformEthAddressMiddleware;
exports.default = _default;